import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import AdminMenu from "../../components/Layout/AdminMenu";
import toast from "react-hot-toast";
import axios from "axios";
import "../../styles/AdminStyles.css";

const Settings = () => {
  // Phone & Contact
  const [phone, setPhone] = useState("00971542237463");
  const [whatsapp, setWhatsapp] = useState("00971542237463");
  const [email, setEmail] = useState("info@alnakhba-store.shop");
  const [address, setAddress] = useState("العراق - بغداد - شارع المنصور");

  // Payment Methods
  const [paymentMethods, setPaymentMethods] = useState([
    { name: "الدفع عند الاستلام", enabled: true, details: "" },
  ]);

  const [loading, setLoading] = useState(false);

  // Load settings on mount
  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const { data } = await axios.get("/api/v1/settings/get-settings");
      if (data?.success) {
        const s = data.settings;
        if (s.phone) setPhone(s.phone);
        if (s.whatsapp) setWhatsapp(s.whatsapp);
        if (s.email) setEmail(s.email);
        if (s.address) setAddress(s.address);
        if (s.paymentMethods) setPaymentMethods(s.paymentMethods);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSaveContact = async () => {
    setLoading(true);
    try {
      await axios.put("/api/v1/settings/bulk-update", {
        settings: [
          { key: "phone", value: phone },
          { key: "whatsapp", value: whatsapp },
          { key: "email", value: email },
          { key: "address", value: address },
        ],
      });
      toast.success("تم حفظ معلومات التواصل بنجاح");
    } catch (error) {
      console.log(error);
      toast.error("حدث خطأ في حفظ الإعدادات");
    }
    setLoading(false);
  };

  const handleSavePayment = async () => {
    setLoading(true);
    try {
      await axios.put("/api/v1/settings/update-setting", {
        key: "paymentMethods",
        value: paymentMethods,
      });
      toast.success("تم حفظ طرق الدفع بنجاح");
    } catch (error) {
      console.log(error);
      toast.error("حدث خطأ في حفظ طرق الدفع");
    }
    setLoading(false);
  };

  const addPaymentMethod = () => {
    setPaymentMethods([
      ...paymentMethods,
      { name: "", enabled: true, details: "" },
    ]);
  };

  const removePaymentMethod = (index) => {
    setPaymentMethods(paymentMethods.filter((_, i) => i !== index));
  };

  const updatePaymentMethod = (index, field, value) => {
    const updated = [...paymentMethods];
    updated[index][field] = value;
    setPaymentMethods(updated);
  };

  return (
    <Layout title={"إعدادات المتجر - النخبة ستور"}>
      <div className="container-fluid admin-layout">
        <div className="row">
          <div className="col-md-3">
            <AdminMenu />
          </div>
          <div className="col-md-9">
            <div className="admin-page-header">
              <h1>إعدادات المتجر</h1>
              <p>إدارة معلومات التواصل وطرق الدفع</p>
              <div className="admin-page-header-line"></div>
            </div>

            {/* Contact Settings */}
            <div className="admin-form-card mb-4">
              <h4 style={{ color: "var(--gold)", marginBottom: "20px", fontWeight: 700 }}>
                📞 معلومات التواصل
              </h4>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label>رقم الهاتف</label>
                  <input
                    type="text"
                    className="form-control"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="00971542237463"
                    dir="ltr"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label>رقم الواتساب (مع رمز الدولة)</label>
                  <input
                    type="text"
                    className="form-control"
                    value={whatsapp}
                    onChange={(e) => setWhatsapp(e.target.value)}
                    placeholder="00971542237463"
                    dir="ltr"
                  />
                </div>
              </div>

              <div className="mb-3">
                <label>البريد الإلكتروني</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="info@alnakhba-store.shop"
                  dir="ltr"
                />
              </div>

              <div className="mb-3">
                <label>العنوان</label>
                <input
                  type="text"
                  className="form-control"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  placeholder="العراق - بغداد - شارع المنصور"
                />
              </div>

              <button
                className="btn btn-gold-shimmer w-100 mt-2"
                onClick={handleSaveContact}
                disabled={loading}
              >
                {loading ? "جاري الحفظ..." : "💾 حفظ معلومات التواصل"}
              </button>
            </div>

            {/* Payment Methods */}
            <div className="admin-form-card">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 style={{ color: "var(--gold)", fontWeight: 700, margin: 0 }}>
                  💳 طرق الدفع
                </h4>
                <button
                  className="btn btn-outline-gold"
                  onClick={addPaymentMethod}
                  style={{
                    border: "1px solid var(--gold)",
                    color: "var(--gold)",
                    borderRadius: "10px",
                    padding: "6px 16px",
                    fontSize: "0.85rem",
                  }}
                >
                  ➕ إضافة طريقة دفع
                </button>
              </div>

              {paymentMethods.map((method, index) => (
                <div
                  key={index}
                  className="admin-card mb-3"
                  style={{
                    padding: "18px",
                    border:
                      method.enabled
                        ? "1px solid rgba(40, 167, 69, 0.25)"
                        : "1px solid rgba(201, 168, 76, 0.1)",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div className="d-flex align-items-center gap-3 flex-grow-1">
                      <label className="admin-switch">
                        <input
                          type="checkbox"
                          checked={method.enabled}
                          onChange={(e) =>
                            updatePaymentMethod(index, "enabled", e.target.checked)
                          }
                        />
                        <span className="switch-slider"></span>
                      </label>
                      <span
                        style={{
                          color: method.enabled ? "#28a745" : "var(--white-muted)",
                          fontSize: "0.8rem",
                          fontWeight: 600,
                        }}
                      >
                        {method.enabled ? "مفعّل" : "معطّل"}
                      </span>
                    </div>
                    {paymentMethods.length > 1 && (
                      <button
                        onClick={() => removePaymentMethod(index)}
                        style={{
                          background: "rgba(220, 53, 69, 0.1)",
                          border: "1px solid rgba(220, 53, 69, 0.25)",
                          color: "#dc3545",
                          borderRadius: "8px",
                          padding: "4px 12px",
                          fontSize: "0.8rem",
                          cursor: "pointer",
                        }}
                      >
                        حذف
                      </button>
                    )}
                  </div>

                  <div className="mb-2">
                    <label>اسم طريقة الدفع</label>
                    <input
                      type="text"
                      className="form-control"
                      value={method.name}
                      onChange={(e) =>
                        updatePaymentMethod(index, "name", e.target.value)
                      }
                      placeholder="مثال: ZainCash, أسيا حوالة, الدفع عند الاستلام"
                    />
                  </div>

                  <div>
                    <label>تفاصيل / مفتاح API</label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={method.details}
                      onChange={(e) =>
                        updatePaymentMethod(index, "details", e.target.value)
                      }
                      placeholder="أدخل تفاصيل طريقة الدفع أو مفتاح API"
                    />
                  </div>
                </div>
              ))}

              <button
                className="btn btn-gold-shimmer w-100 mt-2"
                onClick={handleSavePayment}
                disabled={loading}
              >
                {loading ? "جاري الحفظ..." : "💾 حفظ طرق الدفع"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Settings;
